import { i18nTranslate } from 'src/utils'

const addDefaultSort = props => {
  const optionList = props?.sortOptions || {}
  const defaultSortOption = {
    key: 'featured',
    name: i18nTranslate('plp.BestMatch', 'Best Match', {
      nameSpace: 'ssr-resource',
    }),
  }
  const list = [defaultSortOption].concat(optionList)
  return list
}

export { addDefaultSort }
